/* eslint-disable no-console */
// TEMP DEBUG: remove this file and its call sites once the category exposure decision is understood.
export const debugCategoryExposure = (step: string, details: Record<string, unknown>) => {
    if (typeof window !== 'undefined') {
        console.log(`[category-exposure] ${step}`, details);
    }
};
